var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBellGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 2.9696C8.8639 2.9696 6.1739 5.6596 6.1739 8.9696V11.8596C6.1739 12.4696 5.9139 13.3996 5.6039 13.9196L4.4539 15.8296C3.7439 17.0096 4.2339 18.3196 5.5339 18.7596C9.8439 20.1996 14.4939 20.1996 18.8039 18.7596C20.0139 18.3596 20.5439 16.9296 19.8839 15.8296L18.7339 13.9196C18.4339 13.3996 18.1739 12.4696 18.1739 11.8596V8.9696C18.1739 5.6696 15.4739 2.9696 12.1739 2.9696Z",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0242 3.25951C12.8149 2.9151 11.5335 2.9151 10.3242 3.25951C10.6142 2.51951 11.3342 1.99951 12.1742 1.99951C13.0142 1.99951 13.7342 2.51951 14.0242 3.25951Z",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1738 19.1196C15.1738 20.7696 13.8238 22.1196 12.1738 22.1196C11.3538 22.1196 10.5938 21.7796 10.0538 21.2396C9.49198 20.6769 9.17562 19.9148 9.17383 19.1196",
    stroke: "#f9bc03",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBellGreen);
export default __webpack_public_path__ + "static/media/ic_bell_green.e8c7bc1ba3e89044ffdeef5f2add8903.svg";
export { ForwardRef as ReactComponent };